export const getRandomId = () =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15);

// borrowed from swiper
// https://github.com/nolimits4web/swiper/blob/master/src/components/core/events/onTouchStart.js
const EDGE_SWIPE_THRESHOLD = 20;
const preventEdgeSwipe = event => {
  const e = event.originalEvent || event;
  const startX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  if (startX <= EDGE_SWIPE_THRESHOLD || startX >= window.innerWidth - EDGE_SWIPE_THRESHOLD) {
    // prevent edge swipe
    event.preventDefault();
  }
};

const preventPinchToZoom = event => {
  if (event.touches.length > 1) event.preventDefault();
};

export const disableEdgeSwipeNavigation = () => {
  document.addEventListener('touchstart', preventEdgeSwipe, { passive: false });
};

export const enableEdgeSwipeNavigation = () => {
  document.removeEventListener('touchmove', preventEdgeSwipe);
};

export const disablePinchToZoom = () => {
  document.addEventListener('touchmove', preventPinchToZoom, { passive: false });
};

export const enablePinchToZoom = () => {
  document.removeEventListener('touchmove', preventPinchToZoom);
};

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export const isIOS = () =>
  (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !Object.prototype.hasOwnProperty.call(window, 'MSStream');

// https://davidwalsh.name/detect-android
export const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("android") > -1;
}

// loosely based on the http://get.webgl.org
export function supportsWebGL() {
  const testCanvas = document.createElement('canvas');
  let gl = null;
  let isWebgl = false;
  try {
    gl = testCanvas.getContext('webgl');
  } catch (x) {
    gl = null;
  }
  if (gl == null) {
    try {
      gl = testCanvas.getContext('experimental-webgl');
    } catch (x) {
      gl = null;
    }
  }
  isWebgl = !!gl;
  return isWebgl;
}

// https://codepen.io/tteske/pen/KKwxOxp
// https://www.geeksforgeeks.org/how-to-detect-touch-screen-device-using-javascript/
export const isTouchDevice = () => {
  return (
    'ontouchstart' in document.documentElement ||
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};
